<div class="page page--quaternary">
    <div class="page__inner">
        <app-logo-bg></app-logo-bg>

        <a id="credit_card_back_mobile" [routerLink]="getBackLink()" class="page__back page__back--mobile page__back--mobile-text">
            <span class="visually-hidden">Cancel</span>
        </a>
        <h1 class="page__title">ADD <span class="hide-on-square">NEW</span> CARD</h1>
        <p class="page__notification" *ngIf="notification">{{notification}}</p>
        <div class="page__form">
            <form [formGroup]="newCardForm" (ngSubmit)="onSubmit()" class="form-simple form-simple--primary">
                <div class="form-simple__item">
                    <input formControlName="first_name"
                           placeholder="First Name"
                           [type]="'text'"
                           class="form-simple__input"
                           autocomplete="off">
                </div>

                <div class="form-simple__item">
                    <input formControlName="last_name"
                           placeholder="Last Name"
                           [type]="'text'"
                           class="form-simple__input"
                           autocomplete="off">
                </div>

                <div class="form-simple__item">
                    <input mask="0000 0000 0000 0000"
                           formControlName="card_number"
                           placeholder="Card Number"
                           [type]="'tel'"
                           class="form-simple__input"
                           autocomplete="off">
                </div>

                <div class="form-simple__row">
                    <div class="form-simple__item">
                        <input formControlName="exp"
                               mask="00/00"
                               placeholder="Exp MM/YY"
                               [type]="'tel'"
                               class="form-simple__input"
                               autocomplete="off">
                    </div>
                    <div class="form-simple__item">
                        <input formControlName="cvv"
                               mask="000"
                               placeholder="CVV"
                               [type]="'tel'"
                               class="form-simple__input"
                               autocomplete="off">
                    </div>
                </div>

                <div class="form-simple__item">
                    <input formControlName="city"
                           placeholder="City"
                           [type]="'text'"
                           class="form-simple__input"
                           autocomplete="off">
                </div>

                <div class="form-simple__item" *ngIf="states.length">
                    <mat-form-field>
                        <!-- <mat-label>GET</mat-label> -->
<!--                        [(value)]="selectedMethod"-->
                        <mat-select #stateSelect
                                    formControlName="state"
                                    [(value)]="selectedState"
                                    panelClass="my-select-panel-border-yellow">
                            <mat-select-trigger>
                                {{stateSelect?.value?.name}}
                            </mat-select-trigger>
                            <mat-option *ngFor="let state of states" [value]="state">
                                {{state.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-simple__item">
                    <input formControlName="billing_address"
                           placeholder="Billing Address"
                           [type]="'text'"
                           class="form-simple__input"
                           autocomplete="off">
                </div>

                <div class="form-simple__item">
                    <input formControlName="billing_zip"
                           mask="00000"
                           placeholder="Billing Zip"
                           [type]="'tel'"
                           class="form-simple__input"
                           autocomplete="off">
                </div>

                <div class="form-simple__item">
                    <input formControlName="card_nickname"
                           placeholder="Card Nickname"
                           [type]="'text'"
                           (change)="onInput($event)"
                           class="form-simple__input"
                           autocomplete="off">
                </div>

                <div class="form-simple__btns">
                    <button id="save_credit_card" class="js-submit-btn button snake-btn is-notouched" [disabled]="newCardForm.invalid">
                        SAVE
                        <svg><rect></rect></svg>
                    </button>
                </div>
            </form>
        </div>
        <a id="credit_card_back" [routerLink]="getBackLink()" class="button page__back page__back--desktop" >
            CANCEL
            <svg><rect></rect></svg>
        </a>
    </div>
    <svg [ngStyle]="{fill: getActiveColor()}" class="page-wrapper__decor-bottom page-wrapper__decor-bottom--square" width="324" height="12" viewBox="0 0 324 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="317.999" cy="6.00002" rx="5.99998" ry="5.99998" transform="rotate(-180 317.999 6.00002)"/>
        <circle cx="284.999" cy="5.99996" r="5.99998" transform="rotate(-180 284.999 5.99996)"/>
        <circle cx="251.999" cy="5.99996" r="5.99998" transform="rotate(-180 251.999 5.99996)"/>
        <circle cx="6.00002" cy="5.99996" r="5.99998" transform="rotate(-180 6.00002 5.99996)"/>
        <line [ngStyle]="{stroke: getActiveColor()}" x1="227.999" y1="7.50003" x2="62.999" y2="7.50002" stroke-width="3"/>
    </svg>
</div>

